import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getEvaluationList, deleteEvaluation } from '../services/evaluationService';
import EvaluationList from '../components/evaluation/EvaluationList';
import Button from '../components/common/Button';
import { FiPlus } from 'react-icons/fi';

const EvaluationListPage = () => {
  const [evaluations, setEvaluations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  // 加载评估记录列表
  const loadEvaluations = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const response = await getEvaluationList(page, 20);
      setEvaluations(response.items);
      setTotalPages(Math.ceil(response.total / 20));
    } catch (err) {
      setError('加载评估记录列表失败');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [page]);

  // 初始加载
  useEffect(() => {
    loadEvaluations();
  }, [loadEvaluations]);

  // 处理评估记录选择
  const handleSelectEvaluation = (id) => {
    navigate(`/evaluations/${id}`);
  };

  // 处理删除评估记录 - 直接删除无需确认
  const handleDeleteEvaluation = async (id) => {
    try {
      await deleteEvaluation(id);
      // 刷新评估记录列表
      setEvaluations(prev => prev.filter(item => item.id !== id));
    } catch (err) {
      console.error('删除评估记录失败:', err);
      setError('删除评估记录失败');
    }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-12rem)]">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">评估记录</h1>
        <Button
          onClick={() => navigate('/evaluate')}
          className="flex items-center gap-1"
        >
          <FiPlus className="h-4 w-4" />
          新建评估
        </Button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center flex-grow">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      ) : error ? (
        <div className="p-4 rounded-md bg-destructive/10 text-destructive">
          {error}
        </div>
      ) : (
        <div className="flex-grow">
          <EvaluationList
            evaluations={evaluations}
            onSelect={handleSelectEvaluation}
            onDelete={handleDeleteEvaluation}
          />
        </div>
      )}

      {totalPages > 1 && (
        <div className="flex justify-center mt-6">
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              上一页
            </Button>
            <span className="text-sm text-muted-foreground">
              第 {page} 页，共 {totalPages} 页
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              下一页
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EvaluationListPage;
